module.exports = __webpack_public_path__ + "12741e4ee984d5430cf3a6fff218b5a8.pdf";